import { render, staticRenderFns } from "./itemDetails.vue?vue&type=template&id=099e2044&scoped=true"
import script from "./itemDetails.vue?vue&type=script&lang=js"
export * from "./itemDetails.vue?vue&type=script&lang=js"
import style0 from "./itemDetails.vue?vue&type=style&index=0&id=099e2044&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099e2044",
  null
  
)

export default component.exports